export default "__VITE_ASSET__BURTTOQD__"